import { IconButton } from '@mui/material';
import { alpha, darken, styled } from '@mui/material/styles';
import Icon from 'components/Icon';
import Tooltip from 'components/Tooltip';
import { openModal } from 'features/modal/modalSlice';
import { ROOM_SETTINGS_CAPTIONS_TAB_INDEX } from 'features/transcripts/constants';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';

const Button = styled(IconButton)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.common.white, 0.3),
  color: theme.palette.common.white,
  transition: theme.transitions.create('color'),
  fontSize: 24,
  width: 32,
  height: 32,
  '&:focus-visible': {
    outline: 'none',
    color: darken(theme.palette.common.white, 0.4),
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.5),
  },
}));

export const CaptionsSettingsControl = () => {
  const { t } = useTranslation('room');
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(
      openModal('roomSettings', {
        activeTab: ROOM_SETTINGS_CAPTIONS_TAB_INDEX,
      })
    );
  };

  return (
    <Tooltip title={t('transcripts.captions_settings')} placement="top">
      <Button onClick={handleClick}>
        <Icon name="settings" />
      </Button>
    </Tooltip>
  );
};
